import { useState, useEffect } from 'react';
import { downloadFiles, getCustomerLeadgerData, getPreviousLedgerData } from '../../Service/ApiService';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { showSuccessAlert } from 'utils/SuccessMessage';
const LedgerPreviousYearController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const [searchText, setSearchText] = useState('');

  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (user.userVerticalId !== 'Garment') {
      getCustomer();
    }
  }, [searchText]);

  useEffect(() => {
    fetchLedgerData(user.userCode);
  }, []);

  useEffect(() => {
    const totalDebit = ledgerData.reduce(
      (sum, item) => sum + parseFloat(item.debit || 0),
      0
    );
  
    const totalCredit = ledgerData.reduce(
      (sum, item) => sum + parseFloat(item.credit || 0),
      0
    );
  
    setTotalDebit(Number(totalDebit.toFixed(2)));
    setTotalCredit(Number(totalCredit.toFixed(2)));
  
  }, [ledgerData]);

  const handleInputChange = (inputValue, actionMeta) => {
    if (actionMeta?.action === 'input-change') {
      setSearchText(inputValue);
    }
  };

  const handleViewClick = (rowData) => {
    const ledgerData = {
      partyCode: rowData.partyCode,
      month: rowData.month,
      year: rowData.year,
      opening: rowData.opening
    };

    localStorage.setItem('ledgerData', JSON.stringify(ledgerData));
    navigate('/ledgerPreviousYearDetails');
  };

  const handleDownloadAll = async () => {
    setcLoading(true);
    const param = `partyCode=${formData.customer?.value || user.userCode}`;
    // const param = `partyCode=1000`;
    const response = await downloadFiles(param, 'downloadAllpreviousYearLeadger.php', 'divoutAll.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const handleDownloadClick = async (rowData) => {
    setcLoading(true);
    const param = `partyCode=${rowData.partyCode}&month=${rowData.month}&year=${rowData.year}&opening=${rowData.opening}`;
    const response = await downloadFiles(param, 'previousledgerDownalod.php', 'ledgerFile.xls');
    if (response == true) {
      showSuccessAlert('Ledger File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const getCustomer = async () => {
    try {
      const response = await getCustomerLeadgerData(user.userCode, searchText);
      if (response && response.success === 'true') {
        setCustomerOptions([]);

        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
    } catch (error) {
      setCustomerOptions([]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      fetchLedgerData(formData.customer?.value || user.userCode); // Use the new function
    }
  };

  const fetchLedgerData = async (customerCode) => {
    try {
      setcLoading(true);
      const response = await getPreviousLedgerData(customerCode);
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.ledgerList);
      } else {
        setLedgerData([]);
      }
      setcLoading(false);
    } catch (error) {
      setcLoading(false);
    }
  };

  const handleCustomerChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['customer']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

    }
  };

  return {
    ledgerData,
    totalDebit,
    totalCredit,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleViewClick,
    handleDownloadAll,
    handleDownloadClick
  };
};

export default LedgerPreviousYearController;
